// initial state
// shape: [{ id, quantity }]
const state = {}

// getters
const getters = {
  // demoTable: state => state.table
}

// actions
const actions = {
  getFlBannerTable ({commit, state}, id) {
    let promised = request.alert('getFlBannerTable', id)
    return promised
  },
  deleteFlBanner ({commit, state}, id) {
    let promised = request.alert('deleteFlBanner', id)
    return promised
  },
  createFlBanner ({commit, state}, id) {
    let promised = request.alert('createFlBanner', id)
    return promised
  },
  editFlBanner ({commit, state}, id) {
    let promised = request.alert('editFlBanner', id)
    return promised
  },
  getFlBanner ({commit, state}, id) {
    let promised = request.alert('getFlBanner', id)
    return promised
  },
  uploadFlBanner ({commit, state}, id) {
    let promised = request.alert('uploadFlBanner', id)
    return promised
  },
  getFlBannerLogTable ({commit, state}, params) {
    let promised = request.alert('getFlBannerLogTable', params)
    return promised
  },
}

// mutations
const mutations = {}

export const flbanner = {
  state,
  getters,
  actions,
  mutations,
}



// WEBPACK FOOTER //
// ./src/views/flbanner/flbanner.store.js